import axios from 'axios'
import moment from 'moment'
import qs from 'qs'
import md5 from 'js-md5'
import router from '../router'
const Base64 = require('js-base64').Base64
import { Message } from 'element-ui'
export const api = 'https://datav.eartip.cn/api/'
// export const api = 'http://192.168.0.117:5000/api/'
// const api = 'http://192.168.0.234:5050/api/'
// const api = 'http://119.23.211.94:5050/api/'
// const api = 'http://192.168.0.254:5050/api/'
// const api = 'http://127.0.0.1:5000/api/'
const seApi = 'https://se.eartip.cn'
const timeDiff = 90 * 1000
const delay = parseInt(timeDiff)
axios.defaults.timeout = delay
axios.defaults.retry = 4
axios.defaults.retryDelay = 1000
const http = axios.create({})
http.interceptors.request.use(
  config => {
    config.headers.common['sid'] = storGet('screen') && storGet('screen').sid ? storGet('screen').sid : ''
    if (storGet('screen')) {
      if (storGet('screen').tokenTime) {
        const date = new Date()
        const diff = Number(date.getTime()) - Number(storGet('screen').tokenTime)
        // console.log(diff, '时间差')
        if (diff > (10 * 1000)) {
          const promiseFresh = new Promise((resolve, reject) => {
            getChineseTime().then(res => {
              // const serverDiff = res.data.sreverTimestamp * 1000 - (new Date().getTime())
              // if (Math.abs(serverDiff) > 180 * 1000) {
              //   Message.warning('本电脑时间或时区与当前北京时间不一致，请查看本电脑时间设置！')
              //   return false
              // }
              const tr = (new Date()).getTime().toString()
              console.log(tr, 1111)
              const ob = {
                account: storGet('screen').account,
                _timestamp: tr.substring(0, 10)
                // account: 'wy@user1'
              }
              const needData = {}
              Object.keys(ob).sort().map(key => {
                needData[key] = ob[key]
              })
              const arr = []
              for (const key in needData) {
                arr.push(key.toString() + '=' + needData[key].toString())
              }
              // console.log(arr.join('&'))
              needData.sign = md5(arr.join('&')).toUpperCase()
              // console.log(newData)
              const str = {
                k: Base64.encode(JSON.stringify(needData))
              }
              axios.post(api + 'getToken', qs.stringify(str)).then(res => {
                let d = Base64.decode(res.data.d).replace(/'/g, '"')
                d = JSON.parse(d)
                // console.log(d)
                const obj = storGet('screen')
                obj.token = d.data.token
                obj.tokenTime = (new Date()).getTime()
                // console.log((new Date()).getTime(), '缓存时间')
                storSet('screen', obj)
                config.headers.common['token'] = storGet('screen').token
                resolve(config)
              }).catch(err => {
                Message.warning('验证失效，请重新登录！')
                router.push('/login')
              })
            })
          })
          return promiseFresh
        } else {
          config.headers.common['token'] = storGet('screen').token
          return config
        }
      } else {
        // Message.warning('验证失效，请刷新页面或退出登录重试！！')
        // router.push('/login')
      }
      // token = storGet('screen').token
      // config.headers.common['token'] = token
    } else {
      // console.log('无缓存')
      return config
    }
  },
  err => {
    return Promise.reject(err)
  }
)

async function getChineseTime() {
  const obj = {}
  // await axios.post(api + 'getTimestamp').then(res => {
  //   // console.log(res.data)
  //   obj = res.data
  // }).catch(err => {
  //   Message.warning(err)
  // })
  // console.log(obj)
  return obj
}
// async function getChineseTime() {
//   var httpRequest = new XMLHttpRequest();
//   httpRequest.open('GET', 'http://quan.suning.com/getSysTime.do', true);
//   httpRequest.setRequestHeader("Content-type","application/x-www-form-urlencoded");
//   httpRequest.send(null);
//   let obj
//   httpRequest.onreadystatechange = await function () {
//     if (httpRequest.readyState == 4 && httpRequest.status == 200) {
//       var json = httpRequest.responseText;
//       // console.log(json);
//       obj = json
//     }
//   };
//   return obj
// }
export function post(obj) {
  const ob = obj.data
  // obj._timestamp = (new Date(getChineseTime())).getTime().toString().substring(0, 10)
  getChineseTime().then(res => {
    // console.log(res, 1111)
    // const serverDiff = res.data.sreverTimestamp * 1000 - (new Date().getTime())
    // if (Math.abs(serverDiff) > 180 * 1000) {
    //   Message.warning('本电脑时间或时区与当前北京时间不一致，请查看本电脑时间设置！')
    //   return false
    // }
    const tr = (new Date()).getTime().toString()
    ob._timestamp = tr.substring(0, 10)
    // console.log(typeof (new Date()).getTime())
    const newData = {}
    Object.keys(ob).sort().map(key => {
      newData[key] = ob[key]
    })
    const arr = []
    // console.log(newData)
    for (const key in newData) {
      arr.push(key.toString() + '=' + newData[key].toString())
    }
    newData.sign = md5(arr.join('&')).toUpperCase()
    // console.log(newData)
    const params = {
      k: Base64.encode(JSON.stringify(newData))
    }
    http({
      method: 'post',
      url: api + obj.url,
      data: qs.stringify(params)
    })
      .then(res => {
        // console.log(res, 'dddd')
        // let d = Base64.decode(res.data.d).replace(/null/g, '""')
        let d = Base64.decode(res.data.d)
        // console.log(d)
        d = eval('(' + d + ')')
        // d = (new Function("return " + d))()
        // d = JSON.parse(d)
        // console.log(d)
        const pd = {
          data: d
        }
        if (pd) {
          obj.callback(pd)
        }
      })
      .catch(error => {
        console.log(error)
        obj.error(error)
        if (error.config.timeout == delay) {
          Message.error('请求超时，请检查网络')
        }
      })
  })
}

// export function post(obj) {
//   axios({
//     method: 'post',
//     url: api + obj.url,
//     data: qs.stringify(obj.data)
//   })
//     .then(res => {
//       obj.callback(res)
//     })
//     .catch(error => {
//       // console.log(error)
//       obj.error(error)
//       if (error.config.timeout == delay) {
//         Message.error('请求超时，请检查网络')
//       }
//     })
// }

export const sePost = obj => {
  axios({
    method: 'post',
    url: seApi + obj.url,
    data: qs.stringify(obj.data)
  })
    .then(res => {
      if (res) {
        obj.callback(res)
      }
    })
    .catch(err => {
      console.log(err)
      obj.error('加载失败，请重试！')
    })
}

export function get(obj) {
  axios({
    method: 'get',
    url: obj.url
  })
    .then(res => {
      obj.callback(res)
    })
    .catch(_ => {})
}

export function storSet(name, object, p) {
  const obj = JSON.stringify(object)
  localStorage.setItem(name, obj)
  return localStorage.getItem(name)
}

export function storGet(name) {
  return JSON.parse(localStorage.getItem(name))
}

export function storRemove(name) {
  localStorage.removeItem(name)
}

export function DayTo(date) {
  return moment(date).format('YYYY-MM-DD')
}

/**
 * @return {string}
 */
export function DateTo(date) {
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

export function Date_GMT(date) {
  return moment(date).utcOffset(0).format('YYYY-MM-DD HH:mm:ss')
}
